import {changeEvent, dispatchCustomEvent, fireChangeEvent} from "../../../../../webpack/modules/events";
import {upload} from "../../../../../webpack/modules/ajax";
import {slideDown, slideUp} from "../../../../../webpack/modules-optimized/element-visibility";
import {hideOptionErrors} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page .options[data-option-type="selectable"] .custom-file-input', false, function(element, event) {
    let container = element.closest('.input-group');
    let display = container.querySelector('input[type="text"]');
    let input = container.querySelector('input[type="hidden"]');
    let file = event.target.files[0] || null;
    let prefix = element.dataset.prefix;
    let onlyPrintable = element.dataset.onlyPrintable;
    let error = element.closest('.custom-image, #custom-image').querySelector('.error');

    slideUp(error);
    display.value = '';
    input.value = '';
    element.value = null;

    if (!file) return;

    upload(
        file,
        {prefix: prefix, onlyPrintable: onlyPrintable, file: file},
        function(response) {
            display.value = response.fileInfo.originalName;
            input.value = response.fileInfo.file;
            fireChangeEvent(input, false);
        },
        function(errorMessage) {
            error.innerHTML = errorMessage;
            slideDown(error);
        }
    );
});

changeEvent('#product-page .options[data-option-type="selectable"] input[name="custom-image"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let customImage = element.value;
    let customText = offcanvas.querySelector('input[name="customText"], textarea[name="customText"]');
    let customImageFromWeb = offcanvas.querySelector('input[name="customImageFromWeb"]');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let increment = offcanvas.querySelector('input[name="customPriceIncrement"]');
    let validate = offcanvas.querySelector('.validate');

    dispatchCustomEvent(
        'productCustomImageChanged',
        {
            'option': offcanvas,
            'customImageFromWeb': customImageFromWeb,
            'previewElement': previewElement,
            'increment': increment,
        }
    );

    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (validate && customImage !== '' && (!customText || customText.value !== "")) validate.classList.remove('disabled');
    else if (validate) validate.classList.add('disabled');
    hideOptionErrors(offcanvas);
});

changeEvent('#product-page .options[data-option-type="selectable"] input[name="customImageFromWeb"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let increment = offcanvas.querySelector('input[name="customPriceIncrement"]');
    let validate = offcanvas.querySelector('.validate');
    let customText = offcanvas.querySelector('input[name="customText"], textarea[name="customText"]');

    dispatchCustomEvent(
        'productCustomImageFromWebChanged',
        {
            'option': offcanvas,
            'customImageFromWeb': element,
            'previewElement': previewElement,
            'increment': increment,
            'customImage': offcanvas.querySelector('input[name="custom-image"]'),
            'customImageFile': offcanvas.querySelector('input[name="file-customImage"]'),
            'customImageDisplay': offcanvas.querySelector('input[name="display-custom-image"]'),
            'customText': customText
        }
    );

    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (validate && element.checked && (customText && customText.value !== '' || !customText)) validate.classList.remove('disabled');
    else if (validate) validate.classList.add('disabled');
    hideOptionErrors(offcanvas);
});

changeEvent('#product-page .options[data-option-type="selectable"] input[name="customPriceIncrement"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    if (!offcanvas.querySelector('input[name="custom-image"]')) return;
    let customImage = offcanvas.querySelector('input[name="custom-image"]');
    let customImageFile = offcanvas.querySelector('input[name="file-customImage"]');
    let customImageDisplay = offcanvas.querySelector('input[name="display-custom-image"]');
    let customImageFromWeb = offcanvas.querySelector('input[name="customImageFromWeb"]');
    let customText = offcanvas.querySelector('input[name="customText"], textarea[name="customText"]');
    let validate = offcanvas.querySelector('.validate');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);

    dispatchCustomEvent(
        'productCustomImageIncrementChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
            'increment': element,
            'customImage': customImage,
            'customImageFile': customImageFile,
            'customImageDisplay': customImageDisplay,
            'customImageFromWeb': customImageFromWeb,
        }
    );

    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (validate && (customImage.value !== '' || (customImageFromWeb && customImageFromWeb.checked)) && (customText && customText.value !== '' || !customText)) validate.classList.remove('disabled');
    else if (validate) validate.classList.add('disabled');
    hideOptionErrors(offcanvas);
});